import { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import AppTopbar from './AppTopbar';
// import AppConfig from './AppConfig';
import useAuth from "../src/hooks/useAuth";

// import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import './AppCelebration.css';
import "@fortawesome/fontawesome-free/css/all.min.css";

import { Dashboard } from './components/dashbord';
import { User } from './components/user';
import { Page } from './components/page';
import { Role } from './components/role';
import { IndustryType } from './components/industrytype';
import { Partner } from './components/partner';
import { PartnerPOC } from './components/partnerpoc';
import { Profile } from './components/profile';
import { Source } from './components/source';
import { Lead } from './components/lead';
import { Status } from './components/status';
import { Contact } from './components/contact';
import { Department } from './components/department';
import { Country } from './components/country';
import { State } from './components/state';
import { City } from './components/city';
import { Resort } from './components/resort';
// import { Enquiry } from './components/enquiry';
import { MyLead } from './components/myLead';
import { PurposeOfTrip } from './components/purposeoftrip';
import { PickupLocation } from './components/pickuplocation';
import { VehicleType } from './components/vehicletype';
import { Package } from './components/package';
import { FoodPackagePrice } from './components/foodpackageprice';
import { Activity } from './components/activity';
import { RoomCategory } from './components/roomCategory';
import { ImageGallery } from './components/imageGallery';
import { Blog } from './components/blog';
import { About } from './components/about';
import { FAQ } from './components/fAQ';
import { SitePackages } from './components/sitePackages';
import { RoomTariff } from './components/roomTariff';
import { Carousel } from './components/Carousel';
import { SitePages } from './components/sitePages';
import { Services } from './components/services';
import { ContactUs } from './components/contactUs';
import { EmailTemplate } from './components/emailTemplate';
import { Itinerary } from './components/itinerary';
import { Hotel } from './components/hotel';
import { HotelCategory } from './components/hotelCategory';
import { BedType } from './components/bedtype';
import { Amenity } from './components/amenity';
import { RoomGlobalType } from './components/roomGlobalType';
import { HotelChain } from './components/hotelChain';
import { TourType } from './components/tourtype';
import { ActivityType } from './components/activitytype';
import { ParameterMast } from './components/parametermast';
import { Support } from './components/support';
import { BulkUpload } from './components/BulkUpload/bulkUpload';
import { MyTeamLead } from './components/myTeamLead';
import { WpTemplate } from './components/wpTemplate';

const App = () => {
    const [menuActive, setMenuActive] = useState(false);
    const [menuMode, setMenuMode] = useState('horizontal');

    const [colorScheme, setColorScheme] = useState('light');
    const [menuTheme, setMenuTheme] = useState('layout-sidebar-white');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [topbarUserMenuActive, setTopbarUserMenuActive] = useState(false);
    const [topbarNotificationMenuActive, setTopbarNotificationMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(false);
    // const [logoColor, setLogoColor] = useState('white');
    // const [componentTheme, setComponentTheme] = useState('blue');
    // const [logoUrl, setLogoUrl] = useState('assets/layout/images/logo-dark.svg');

    const copyTooltipRef = useRef();
    const location = useLocation();
    const { loginObj, pageFeatures, hasPermission } = useAuth();
    // console.log("loginObj", loginObj);
    let menuClick = false;
    // let searchClick = false;
    let userMenuClick = false;
    let notificationMenuClick = false;
    let configClick = false;

    const dashboardUrls = ["dashboard"];
    const leadUrls = ["contact", "lead", "mylead", "bulkUpload", "myTeamLead"];
    const masterUrls = ["resort", "industrytype", "tourtype", "country", "state", "city", "partner", "partnerpoc", "source", "status", "wpTemplate", "department", "purposeoftrip", "pickuplocation", "vehicletype", "package", "foodpackageprice", "activityType", "activity", "itinerary", 'parameterMast',];
    const hotelUrls = ["hotelCategory", "hotel", "bedtype", "amenity", "hotelChain", "roomGlobalType"];
    const siteUrls = ["roomCategory", "blog", "about", "faq", "imageGallery", "sitePackages", "roomTariff", "carousel", "sitePages", "services", "contactUs"];
    const settingUrls = ["role", "user", "page", "emailTemplate", "support"];

    const reportUrls = [];

    const breadcrumb = [
        { path: '/dashboard', parent: 'Dashboard', label: 'Dashboard' },
        { path: '/login', parent: 'Login', label: 'Login' },
        { path: '/profile', parent: 'Profile', label: 'Profile' }
    ];

    const menu = [];
    const menuMap = {};

    const addMenuSection = (label, icon) => {
        if (!menuMap[label]) {
            let section = { label, icon, items: [] };
            menu.push(section, { separator: true });
            menuMap[label] = section;
        }
    };

    if (pageFeatures.some(page => (page.permission && dashboardUrls.includes(page.url)))) addMenuSection('Dashboard', 'pi pi-fw pi-home');
    if (pageFeatures.some(page => (page.permission && leadUrls.includes(page.url)))) addMenuSection('Lead', 'pi pi-fw pi-table');
    if (pageFeatures.some(page => (page.permission && masterUrls.includes(page.url)))) addMenuSection('Masters', 'pi pi-briefcase');
    if (pageFeatures.some(page => (page.permission && hotelUrls.includes(page.url)))) addMenuSection('Hotel', 'pi pi-building');
    if (pageFeatures.some(page => (page.permission && settingUrls.includes(page.url)))) addMenuSection('Settings', 'pi pi-cog');
    if (pageFeatures.some(page => (page.permission && siteUrls.includes(page.url)))) addMenuSection('Site', 'pi pi-link');
    if (pageFeatures.some(page => (page.permission && reportUrls.includes(page.url)))) addMenuSection('Reports', 'pi pi-chart-bar');

    pageFeatures.forEach(page => {
        if (page.permission && page.url !== "skip") {
            let category = 'Dashboard';
            if (leadUrls.includes(page.url)) category = 'Lead';
            else if (masterUrls.includes(page.url)) category = 'Masters';
            else if (settingUrls.includes(page.url)) category = 'Settings';
            else if (hotelUrls.includes(page.url)) category = 'Hotel';
            else if (reportUrls.includes(page.url)) category = 'Reports';
            else if (siteUrls.includes(page.url)) category = 'Site';

            breadcrumb.push({
                path: "/" + page.url,
                parent: category,
                label: page.label
            });

            let menuItem = {
                label: page.label,
                icon: 'pi pi-fw pi-circle',
                to: "/" + page.url
            };

            if (menuMap[category])
                menuMap[category].items.push(menuItem);
            else console.warn(`Menu category ${category} not found for page ${page.label}`);
        }
    });

    let meta = breadcrumb.find((obj) => {
        return obj.path === location.pathname;
    });

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    // const onInputStyleChange = (inputStyle) => {
    //     setInputStyle(inputStyle);
    // };

    // const changeMenuTheme = (name, logoColor, componentTheme) => {
    //     onMenuThemeChange(name);
    //     changeStyleSheetUrl('theme-css', componentTheme, 2);
    //     setComponentTheme(componentTheme);

    //     const appLogoLink = document.getElementById('app-logo');
    //     const appLogoUrl = `img/logo.svg`;
    //     const horizontalLogoLink = document.getElementById('logo-horizontal');
    //     const horizontalLogoUrl = `img/logo.svg`;

    //     if (appLogoLink) {
    //         appLogoLink.src = appLogoUrl;
    //     }
    //     if (horizontalLogoLink) {
    //         horizontalLogoLink.src = horizontalLogoUrl;
    //     }
    //     setLogoColor(logoColor);
    // };

    // const changeComponentTheme = (theme) => {
    //     setComponentTheme(theme);
    //     changeStyleSheetUrl('theme-css', theme, 3);
    // };

    // const changeColorScheme = (e) => {
    //     setColorScheme(e.value);
    //     const scheme = e.value;
    //     changeStyleSheetUrl('layout-css', 'layout-' + scheme + '.css', 1);
    //     changeStyleSheetUrl('theme-css', 'theme-' + scheme + '.css', 1);
    //     changeLogo(scheme);
    // };

    // const changeStyleSheetUrl = (id, value, from) => {
    //     const element = document.getElementById(id);
    //     const urlTokens = element.getAttribute('href').split('/');

    //     if (from === 1) {
    //         urlTokens[urlTokens.length - 1] = value;
    //     } else if (from === 2) {
    //         if (value !== null) {
    //             urlTokens[urlTokens.length - 2] = value;
    //         }
    //     } else if (from === 3) {
    //         urlTokens[urlTokens.length - 2] = value;
    //     }

    //     const newURL = urlTokens.join('/');
    //     replaceLink(element, newURL);
    // };

    // const changeLogo = (scheme) => {
    //     const appLogoLink = document.getElementById('app-logo');
    //     const mobileLogoLink = document.getElementById('logo-mobile');
    //     const invoiceLogoLink = document.getElementById('invoice-logo');
    //     const footerLogoLink = document.getElementById('footer-logo');
    //     const horizontalLogoLink = document.getElementById('logo-horizontal');
    //     setLogoUrl(`img/logo.svg`);

    //     if (appLogoLink) {
    //         appLogoLink.src = `img/logo.svg`;
    //     }

    //     if (horizontalLogoLink) {
    //         horizontalLogoLink.src = `img/logo.svg`;
    //     }

    //     if (mobileLogoLink) {
    //         mobileLogoLink.src = logoUrl;
    //     }

    //     if (invoiceLogoLink) {
    //         invoiceLogoLink.src = logoUrl;
    //     }

    //     if (footerLogoLink) {
    //         footerLogoLink.src = logoUrl;
    //     }
    // };

    // const replaceLink = (linkElement, href) => {
    //     if (isIE()) {
    //         linkElement.setAttribute('href', href);
    //     } else {
    //         const id = linkElement.getAttribute('id');
    //         const cloneLinkElement = linkElement.cloneNode(true);

    //         cloneLinkElement.setAttribute('href', href);
    //         cloneLinkElement.setAttribute('id', id + '-clone');

    //         linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

    //         cloneLinkElement.addEventListener('load', () => {
    //             linkElement.remove();
    //             const _linkElement = document.getElementById(id);
    //             _linkElement && _linkElement.remove();
    //             cloneLinkElement.setAttribute('id', id);
    //         });
    //     }
    // };

    // const isIE = () => {
    //     return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    // };

    // const onRippleChange = (e) => {
    //     PrimeReact.ripple = e.value;
    //     setRipple(e.value);
    // };

    const onDocumentClick = () => {

        if (!userMenuClick) {
            setTopbarUserMenuActive(false);
        }

        if (!notificationMenuClick) {
            setTopbarNotificationMenuActive(false);
        }

        if (!menuClick) {
            if (isSlim() || isHorizontal()) {
                setMenuActive(false);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                hideOverlayMenu();
            }

            unblockBodyScroll();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        // searchClick = false;
        configClick = false;
        userMenuClick = false;
        notificationMenuClick = false;
        menuClick = false;
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarUserMenuActive(false);
        setTopbarNotificationMenuActive(false);

        if (isOverlay()) {
            setOverlayMenuActive((prevOverlayMenuActive) => !prevOverlayMenuActive);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive);
        } else {
            setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
        }

        event.preventDefault();
    };

    const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();

            if (isSlim() || isHorizontal()) {
                setMenuActive(false);
            }
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive((prevMenuActive) => !prevMenuActive);
    };

    // const onMenuThemeChange = (name) => {
    //     setMenuTheme('layout-sidebar-' + name);
    // };

    // const onMenuModeChange = (e) => {
    //     setMenuMode(e.value);
    //     if (e.value === 'static') {
    //         setStaticMenuDesktopInactive(false);
    //     }
    // };

    const onTopbarUserMenuButtonClick = (event) => {
        userMenuClick = true;
        setTopbarUserMenuActive((prevTopbarUserMenuActive) => !prevTopbarUserMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onTopbarNotificationMenuButtonClick = (event) => {
        notificationMenuClick = true;
        setTopbarNotificationMenuActive((prevTopbarNotificationMenuActive) => !prevTopbarNotificationMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onRightMenuButtonClick = (event) => {
        hideOverlayMenu();
        event.preventDefault();
    };

    // const onConfigClick = () => {
    //     configClick = true;
    // };

    // const onConfigButtonClick = () => {
    //     setConfigActive((prevConfigActive) => !prevConfigActive);
    //     configClick = true;
    // };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
        unblockBodyScroll();
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 1091;
    };

    const containerClassName = classNames(
        'layout-wrapper',
        {
            'layout-overlay': menuMode === 'overlay',
            'layout-static': menuMode === 'static',
            'layout-slim': menuMode === 'slim',
            'layout-horizontal': menuMode === 'horizontal',
            'layout-sidebar-dim': colorScheme === 'dim',
            'layout-sidebar-dark': colorScheme === 'dark',
            'layout-overlay-active': overlayMenuActive,
            'layout-mobile-active': staticMenuMobileActive,
            'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
            'p-input-filled': inputStyle === 'filled',
            'p-ripple-disabled': !ripple
        },
        colorScheme === 'light' ? menuTheme : ''
    );

    return (
        <div className={containerClassName} data-theme={colorScheme} onClick={onDocumentClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <div className="layout-content-wrapper">
                <AppTopbar
                    meta={meta}
                    topbarNotificationMenuActive={topbarNotificationMenuActive}
                    topbarUserMenuActive={topbarUserMenuActive}
                    onMenuButtonClick={onMenuButtonClick}
                    onTopbarNotification={onTopbarNotificationMenuButtonClick}
                    onTopbarUserMenu={onTopbarUserMenuButtonClick}
                    onRightMenuClick={onRightMenuButtonClick}
                    onRightMenuButtonClick={onRightMenuButtonClick}
                    menu={(loginObj.user_Type !== 2 && loginObj.user_Type !== 3) ? menu : menu.filter(e => e.label === "Modules" || e.label === "Requirement")}
                    menuMode={menuMode}
                    menuActive={menuActive}
                    staticMenuMobileActive={staticMenuMobileActive}
                    onMenuClick={onMenuClick}
                    onMenuitemClick={onMenuitemClick}
                    onRootMenuitemClick={onRootMenuitemClick}
                ></AppTopbar>

                <div className="layout-content">
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard hasPermission={hasPermission} />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/roomCategory" element={<RoomCategory />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="/support" element={<Support />} />


                        {hasPermission("User") && <Route path="/user" element={<User hasPermission={hasPermission} />} />}
                        {hasPermission("Page") && <Route path="/page" element={<Page hasPermission={hasPermission} />} />}
                        {hasPermission("Role") && <Route path="/role" element={<Role hasPermission={hasPermission} />} />}
                        {hasPermission("IndustryType") && <Route path="/industrytype" element={<IndustryType hasPermission={hasPermission} />} />}
                        {hasPermission("Partner") && <Route path="/partner" element={<Partner hasPermission={hasPermission} />} />}
                        {hasPermission("PartnerPOC") && <Route path="/partnerpoc" element={<PartnerPOC hasPermission={hasPermission} />} />}
                        {hasPermission("Source") && <Route path="/source" element={<Source hasPermission={hasPermission} />} />}
                        {hasPermission("Lead") && <Route path="/lead" element={<Lead hasPermission={hasPermission} />} />}
                        {hasPermission("MyLead") && <Route path="/mylead" element={<MyLead hasPermission={hasPermission} />} />}
                        {hasPermission("Status") && <Route path="/status" element={<Status hasPermission={hasPermission} />} />}
                        {hasPermission("WpTemplate") && <Route path="/wpTemplate" element={<WpTemplate hasPermission={hasPermission} />} />}
                        {hasPermission("Contact") && <Route path="/contact" element={<Contact hasPermission={hasPermission} />} />}
                        {hasPermission("Department") && <Route path="/department" element={<Department hasPermission={hasPermission} />} />}
                        {hasPermission("Country") && <Route path="/country" element={<Country hasPermission={hasPermission} />} />}
                        {hasPermission("State") && <Route path="/state" element={<State hasPermission={hasPermission} />} />}
                        {hasPermission("City") && <Route path="/city" element={<City hasPermission={hasPermission} />} />}
                        {hasPermission("Resort") && <Route path="/resort" element={<Resort hasPermission={hasPermission} />} />}
                        {/* {hasPermission("Enquiry") && <Route path="/enquiry" element={<Enquiry hasPermission={hasPermission} />} />} */}
                        {hasPermission("PurposeOfTrip") && <Route path="/purposeoftrip" element={<PurposeOfTrip hasPermission={hasPermission} />} />}
                        {hasPermission("PickupLocation") && <Route path="/pickuplocation" element={<PickupLocation hasPermission={hasPermission} />} />}
                        {hasPermission("VehicleType") && <Route path="/vehicletype" element={<VehicleType hasPermission={hasPermission} />} />}
                        {hasPermission("Package") && <Route path="/package" element={<Package hasPermission={hasPermission} />} />}
                        {hasPermission("FoodPackagePrice") && <Route path="/foodpackageprice" element={<FoodPackagePrice hasPermission={hasPermission} />} />}
                        {hasPermission("Activity") && <Route path="/activity" element={<Activity hasPermission={hasPermission} />} />}
                        {hasPermission("ActivityType") && <Route path="/activityType" element={<ActivityType hasPermission={hasPermission} />} />}
                        {hasPermission("RoomCategory") && <Route path="/roomCategory" element={<RoomCategory hasPermission={hasPermission} />} />}
                        {hasPermission("Blog") && <Route path="/blog" element={<Blog hasPermission={hasPermission} />} />}
                        {hasPermission("About") && <Route path="/about" element={<About hasPermission={hasPermission} />} />}
                        {hasPermission("FAQ") && <Route path="/faq" element={<FAQ hasPermission={hasPermission} />} />}

                        {hasPermission("BulkUpload") && <Route path="/bulkUpload" element={<BulkUpload hasPermission={hasPermission} />} />}

                        {hasPermission("ImageGallery") && <Route path="/imageGallery" element={<ImageGallery hasPermission={hasPermission} />} />}
                        {hasPermission("SitePackages") && <Route path="/sitePackages" element={<SitePackages hasPermission={hasPermission} />} />}
                        {hasPermission("RoomTariff") && <Route path="/roomTariff" element={<RoomTariff hasPermission={hasPermission} />} />}
                        {hasPermission("Carousel") && <Route path="/carousel" element={<Carousel hasPermission={hasPermission} />} />}
                        {hasPermission("SitePages") && <Route path="/sitePages" element={<SitePages hasPermission={hasPermission} />} />}
                        {hasPermission("Services") && <Route path="/services" element={<Services hasPermission={hasPermission} />} />}
                        {hasPermission("ContactUs") && <Route path="/contactUs" element={<ContactUs hasPermission={hasPermission} />} />}
                        {hasPermission("EmailTemplate") && <Route path="/emailTemplate" element={<EmailTemplate hasPermission={hasPermission} />} />}
                        {hasPermission("Itinerary") && <Route path="/itinerary" element={<Itinerary hasPermission={hasPermission} />} />}
                        {hasPermission("Hotel") && <Route path="/hotel" element={<Hotel hasPermission={hasPermission} />} />}
                        {hasPermission("HotelCategory") && <Route path="/hotelCategory" element={<HotelCategory hasPermission={hasPermission} />} />}
                        {hasPermission("BedType") && <Route path="/bedtype" element={<BedType hasPermission={hasPermission} />} />}
                        {hasPermission("Amenity") && <Route path="/amenity" element={<Amenity hasPermission={hasPermission} />} />}
                        {hasPermission("RoomGlobalType") && <Route path="/roomGlobalType" element={<RoomGlobalType hasPermission={hasPermission} />} />}
                        {hasPermission("HotelChain") && <Route path="/hotelChain" element={<HotelChain hasPermission={hasPermission} />} />}
                        {hasPermission("TourType") && <Route path="/tourtype" element={<TourType hasPermission={hasPermission} />} />}
                        {hasPermission("ParameterMast") && <Route path="/parameterMast" element={<ParameterMast hasPermission={hasPermission} />} />}
                        {hasPermission("Support") && <Route path="/support" element={<Support hasPermission={hasPermission} />} />}
                        {hasPermission("MyTeamLead") && <Route path="/myTeamLead" element={<MyTeamLead hasPermission={hasPermission} />} />}

                        <Route path="*" element={<Navigate to='/dashboard' />} />
                    </Routes>
                </div>
            </div>

            {/* <AppConfig
                configActive={configActive}
                menuMode={menuMode}
                onMenuModeChange={onMenuModeChange}
                colorScheme={colorScheme}
                changeColorScheme={changeColorScheme}
                menuTheme={menuTheme}
                changeMenuTheme={changeMenuTheme}
                componentTheme={componentTheme}
                changeComponentTheme={changeComponentTheme}
                onConfigClick={onConfigClick}
                onConfigButtonClick={onConfigButtonClick}
                rippleActive={ripple}
                onRippleChange={onRippleChange}
                inputStyle={inputStyle}
                onInputStyleChange={onInputStyleChange}
            ></AppConfig> */}
        </div >
    );
};

export default App;
